import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ShareIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
    >
      <path d="m22.4 8.8-6-6a.4.4 0 0 0-.5.3l-.1 2.7a9.7 9.7 0 0 0-8.6 2.8c-3.9 3.8-2.7 9.3-2.7 9.3v.5S5.1 14 9 12.1a8 8 0 0 1 6.4-.3l-.2 2.6a.4.4 0 0 0 .4.4l6.8-5c.2-.2.4-.3.4-.5s-.2-.3-.4-.5z" />
    </SVG>
  );
};
